package com.writerslab.office

import org.jetbrains.compose.web.css.*

object C {
    const val Bg = "#15131A"
    const val Surface = "#1E1C2A"
    const val SurfaceHigh = "#252333"
    const val Border = "rgba(165,164,195,0.15)"
    const val Primary = "#A5AEF7"
    const val OnSurface = "#E6E0E9"
    const val Muted = "#9A94A8"
    const val Error = "#F47072"
    const val Success = "#6FCF97"
    const val Warning = "#F2C94C"
}

fun StyleScope.card() {
    backgroundColor(Color(C.Surface))
    borderRadius(8.px)
    padding(16.px)
    property("border", "1px solid ${C.Border}")
}

fun StyleScope.btn(bg: String = C.Primary, fg: String = "#15131A") {
    backgroundColor(Color(bg))
    color(Color(fg))
    border(0.px)
    borderRadius(6.px)
    padding(8.px, 16.px)
    cursor("pointer")
    property("font-size", "13px")
    property("font-weight", "600")
    property("white-space", "nowrap")
}

fun StyleScope.label() {
    fontSize(11.px)
    property("text-transform", "uppercase")
    property("letter-spacing", "0.6px")
    color(Color(C.Muted))
    property("font-weight", "600")
}

fun StyleScope.mono() {
    property("font-family", "'Courier New', monospace")
    fontSize(12.px)
}

fun StyleScope.tableStyle() {
    width(100.percent)
    property("border-collapse", "collapse")
    color(Color(C.OnSurface))
    fontSize(13.px)
}
